export default "__VITE_ASSET__bd15c4d2__"